import { render, staticRenderFns } from "./ExplainAI.vue?vue&type=template&id=4d38fff2&scoped=true"
import script from "./ExplainAI.vue?vue&type=script&lang=js"
export * from "./ExplainAI.vue?vue&type=script&lang=js"
import style0 from "./ExplainAI.vue?vue&type=style&index=0&id=4d38fff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d38fff2",
  null
  
)

export default component.exports